import React, { useState } from "react";
import SideMenu from "../../../sharedScreens/menuItems/SideMenu";
import Header from "../../../sharedScreens/Header";
import MuiButton from "../../../components/basicComponent/MuiButton";
import { MuiInput } from "../../../components/basicComponent/MuiInput";
import { FormikValues, useFormik } from "formik";
import MuiDatePicker from "../../../components/basicComponent/MuiDatePicker";
import dayjs from "dayjs";
import { MuiDropDown } from "../../../components/basicComponent/MuiDropDown";
import { ManageBookingSchema } from "../../../validations/Schema";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { FormControlLabel, FormGroup, FormLabel, Radio } from "@mui/material";
import MuiSearchSelect from "../../../components/basicComponent/MuiSearchSelect";
import MuiRadioButton from "../../../components/basicComponent/MuiRAdioButton";

const FlightSchedule = () => {
  const typeList = [
    { label: "All", value: "All" },
    { label: "Live", value: "Live" },
    { label: "To be Cancelled", value: "To be Cancelled" },
    { label: "Cancelled", value: "Cancelled" },
  ];

  const paymentMode = [
    { label: "TopUp", value: "TopUp" },
    { label: "Payment Gateway", value: "Payment Gateway" },
    { label: "Credit", value: "Credit" },
  ];

  const initialValues = {
    spnr: "",
    hotelConfirmation: "",
    fromDate: "",
    toDate: "",
    searchBy: "",
    firstName: "",
    lastName: "",
    customerName: "",
  };

  const formik = useFormik({
    initialValues,
    validationSchema: ManageBookingSchema,
    onSubmit(values, formikHelpers) {
      console.log("Form submitted with values:", values);
    },
  });

  const [activeTab, setActiveTab] = useState("home");
  const handleTabClick = (tab: string) => {
    setActiveTab(tab);
  };

  const [value, setValue] = React.useState("1");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header mb-1 ">
              <h3 className="card-title titlecolorr">Inventory Creation</h3>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Box sx={{ width: "100%", typography: "body1" }}>
                  <TabContext value={value}>
                    <div className="card card-custom ">
                      <TabList
                        onChange={handleChange}
                        aria-label="lab API tabs example"
                      >
                        <Tab
                          label="Inventory Creation"
                          value="1"
                          className={`tab ${
                            activeTab === "home" ? "active" : ""
                          }`}
                        />
                        <Tab
                          label=" Inventory View"
                          value="2"
                          className={`tab ${
                            activeTab === "about" ? "active" : ""
                          }`}
                          onClick={() => handleTabClick("about")}
                        />
                      </TabList>
                      <div className="tab-content">
                        <TabPanel value="1">
                          <div className="card">
                            <div className="card-body">
                              <div className="row">
                                <div className="row mt-3">
                                  <FormLabel
                                    sx={{
                                      color: " #38aecc",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Sector Details
                                    <span style={{ color: "red" }}>*</span>
                                  </FormLabel>
                                  <FormGroup
                                    sx={{
                                      border: "1px solid #ccc",
                                      padding: "8px",
                                      borderRadius: "4px",
                                      width: "100%",
                                      height: "220px",
                                    }}
                                  >
                                    <div className="row">
                                      <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                                        <MuiInput
                                          placeholder="Airline Name"
                                          label={"Airline Name"}
                                          isRequired={true}
                                        />
                                      </div>
                                      <div className="col-xl-2 col-lg-6 col-md-6 mb-3">
                                        <MuiSearchSelect
                                          placeholder="Airline No. "
                                          label={"Airline No. "}
                                          isRequired={true}
                                          options={[]}
                                          onChange={function (
                                            value: string,
                                            id: string,
                                            data: any
                                          ): void {
                                            throw new Error(
                                              "Function not implemented."
                                            );
                                          }}
                                          value={""}
                                        />
                                      </div>
                                      <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
                                        <MuiDatePicker
                                          label="From"
                                          value={null}
                                          onChange={function (
                                            date: string
                                          ): void {
                                            throw new Error(
                                              "Function not implemented."
                                            );
                                          }}
                                        />
                                      </div>
                                      <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
                                        <MuiDatePicker
                                          label="To"
                                          value={null}
                                          onChange={function (
                                            date: string
                                          ): void {
                                            throw new Error(
                                              "Function not implemented."
                                            );
                                          }}
                                        />
                                      </div>
                                      <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                                        <MuiInput
                                          placeholder="Origin"
                                          label={"Origin"}
                                          isRequired={true}
                                        />
                                      </div>
                                      <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
                                        <MuiDatePicker
                                          label="Departure"
                                          value={null}
                                          onChange={function (
                                            date: string
                                          ): void {
                                            throw new Error(
                                              "Function not implemented."
                                            );
                                          }}
                                        />
                                      </div>
                                      <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
                                        <MuiSearchSelect
                                          placeholder="Destination"
                                          label={"Destination"}
                                          isRequired={true}
                                          options={[]}
                                          onChange={function (
                                            value: string,
                                            id: string,
                                            data: any
                                          ): void {
                                            throw new Error(
                                              "Function not implemented."
                                            );
                                          }}
                                          value={""}
                                        />
                                      </div>
                                      <div className="col-xl-2 col-lg-4 col-md-6 mb-3">
                                        <MuiDatePicker
                                          label={"Arrival"}
                                          value={null}
                                          onChange={function (
                                            date: string
                                          ): void {
                                            throw new Error(
                                              "Function not implemented."
                                            );
                                          }}
                                        />
                                      </div>
                                      <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                                        <MuiInput
                                          placeholder="Class"
                                          label={"Class"}
                                          isRequired={true}
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="row mt-3">
                                  <FormLabel
                                    sx={{
                                      color: " #38aecc",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Flight Details
                                    <span style={{ color: "red" }}>*</span>
                                  </FormLabel>
                                  <FormGroup
                                    sx={{
                                      border: "1px solid #ccc",
                                      padding: "8px",
                                      borderRadius: "4px",
                                      width: "100%",
                                      height: "auto",
                                    }}
                                  >
                                    <div className="row">
                                      <form className="p-2 border rounded mb-2">
                                        <div className="row  align-items-end">
                                          <div className="col">
                                            <label className="form-label">
                                              Class
                                            </label>
                                            <select className="form-select">
                                              <option>--Select--</option>
                                              <option>Economy</option>
                                              <option>Business</option>
                                            </select>
                                          </div>

                                          <div className="col">
                                            <label className="form-label">
                                              RBD
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                            />
                                          </div>

                                          <div className="col">
                                            <label className="form-label">
                                              Seat
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                            />
                                          </div>

                                          <div className="col">
                                            <label className="form-label">
                                              Adult Fare
                                            </label>
                                            <input
                                              type="number"
                                              className="form-control"
                                            />
                                          </div>

                                          <div className="col">
                                            <label className="form-label">
                                              Child Fare
                                            </label>
                                            <input
                                              type="number"
                                              className="form-control"
                                            />
                                          </div>

                                          <div className="col">
                                            <label className="form-label">
                                              Infant Fare
                                            </label>
                                            <input
                                              type="number"
                                              className="form-control"
                                            />
                                          </div>

                                          <div className="col">
                                            <label className="form-label">
                                              Markup
                                            </label>
                                            <input
                                              type="number"
                                              className="form-control"
                                            />
                                          </div>
                                          <label className="form-label ">
                                            Baggage
                                          </label>
                                          <div className="col d-flex">
                                            <div className="form-check form-check-inline">
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="baggageAdu"
                                              />
                                              <label
                                                className="form-check-label"
                                                htmlFor="baggageAdu"
                                              >
                                                Adu
                                              </label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="baggageChil"
                                              />
                                              <label
                                                className="form-check-label"
                                                htmlFor="baggageChil"
                                              >
                                                Chil
                                              </label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="baggageInfa"
                                              />
                                              <label
                                                className="form-check-label"
                                                htmlFor="baggageInfa"
                                              >
                                                Infa
                                              </label>
                                            </div>
                                          </div>

                                          <div className="col">
                                            <label className="form-label">
                                              Unit
                                            </label>
                                            <select className="form-select">
                                              <option>--Select--</option>
                                              <option>KG</option>
                                              <option>PC</option>
                                            </select>
                                          </div>

                                          <div className="col">
                                            <label className="form-label">
                                              Refund
                                            </label>
                                            <select className="form-select">
                                              <option>--Select--</option>
                                              <option>Refundable</option>
                                              <option>Non-Refundable</option>
                                            </select>
                                          </div>

                                          <div className="col">
                                            <label className="form-label">
                                              Type
                                            </label>
                                            <select className="form-select">
                                              <option>--Select--</option>
                                              <option>Published</option>
                                              <option>Private</option>
                                            </select>
                                          </div>

                                          <div className="col">
                                            <label className="form-label">
                                              PNR
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                            />
                                          </div>

                                          <div className="col-auto">
                                            <button
                                              type="button"
                                              className="btn btn-success"
                                            >
                                              +
                                            </button>
                                          </div>
                                        </div>
                                      </form>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="row mt-3">
                                  <FormLabel
                                    sx={{
                                      color: " #38aecc",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Exclude
                                    <span style={{ color: "red" }}>*</span>
                                  </FormLabel>
                                  <FormGroup
                                    sx={{
                                      border: "1px solid #ccc",
                                      padding: "8px",
                                      borderRadius: "4px",
                                      width: "100%",
                                      height: "74px",
                                    }}
                                  >
                                    <div className="row">
                                      <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                                        <MuiSearchSelect
                                          placeholder="Flight No."
                                          label={"Flight No."}
                                          isRequired={true}
                                          options={[]}
                                          onChange={function (
                                            value: string,
                                            id: string,
                                            data: any
                                          ): void {
                                            throw new Error(
                                              "Function not implemented."
                                            );
                                          }}
                                          value={""}
                                        />
                                      </div>
                                      <div className="col-xl-4 col-lg-6 col-md-6 mb-3">
                                        <MuiSearchSelect
                                          placeholder="Cabin "
                                          label={"Cabin "}
                                          isRequired={true}
                                          options={[]}
                                          onChange={function (
                                            value: string,
                                            id: string,
                                            data: any
                                          ): void {
                                            throw new Error(
                                              "Function not implemented."
                                            );
                                          }}
                                          value={""}
                                        />
                                      </div>
                                      <div className="col-xl-4 col-lg-4 col-md-6 mb-3">
                                        <MuiInput
                                          placeholder="Class"
                                          label={"Class"}
                                          isRequired={true}
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="pb-2 user-button w-full text-end onboard-btn">
                                  <MuiButton
                                    className="main-clear-btn"
                                    label="Clear"
                                    type="submit"
                                  />
                                  <MuiButton
                                    label="Create"
                                    type="submit"
                                    // disabled={!formik.dirty || !form/ik.isValid}
                                    variant="outlined"
                                    fullWidth={false}
                                    className="main-btn"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </TabPanel>

                        <TabPanel value="2">
                          <div className="row mt-3">
                            <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
                              <MuiSearchSelect
                                placeholder="Flight No."
                                label={"Flight No."}
                                isRequired={true}
                                options={[]}
                                onChange={function (
                                  value: string,
                                  id: string,
                                  data: any
                                ): void {
                                  throw new Error("Function not implemented.");
                                }}
                                value={""}
                              />
                            </div>

                            <div className="col-md-3    ">
                              <div className="">
                                <div className="d-flex justify-content-between">
                                  <FormControlLabel
                                    value="All"
                                    control={<Radio />}
                                    label="All"
                                  />

                                  <FormControlLabel
                                    value="Valid"
                                    control={<Radio />}
                                    label="Valid"
                                  />
                                  <FormControlLabel
                                    value="Expired"
                                    control={<Radio />}
                                    label="Expired"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
                              <MuiSearchSelect
                                placeholder="Sector"
                                label={"Sector"}
                                isRequired={true}
                                options={[]}
                                onChange={function (
                                  value: string,
                                  id: string,
                                  data: any
                                ): void {
                                  throw new Error("Function not implemented.");
                                }}
                                value={""}
                              />
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
                              <MuiDatePicker
                                label={"Effective From"}
                                value={null}
                                onChange={function (date: string): void {
                                  throw new Error("Function not implemented.");
                                }}
                              />
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
                              <MuiDatePicker
                                label={"Effective To"}
                                value={null}
                                onChange={function (date: string): void {
                                  throw new Error("Function not implemented.");
                                }}
                              />
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
                              <MuiSearchSelect
                                placeholder="Supplier"
                                label={"Supplier"}
                                isRequired={true}
                                options={[]}
                                onChange={function (
                                  value: string,
                                  id: string,
                                  data: any
                                ): void {
                                  throw new Error("Function not implemented.");
                                }}
                                value={""}
                              />
                            </div>
                          </div>
                          <div className="user-button w-full">
                            <MuiButton
                              className="clear-btn"
                              label="Clear"
                              onClick={() => formik.resetForm()}
                              type="submit"
                            />
                            <MuiButton
                              className="get-btn"
                              label="Get"
                              onClick={() => {}}
                              type="submit"
                            />
                          </div>
                        </TabPanel>
                      </div>
                    </div>
                  </TabContext>
                </Box>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default FlightSchedule;
